import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import { getPricingName, getPricingDataById } from "../../../../../../components/helper/helper";

function DualPricing({ appData }) {
  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
      </ul>

      {/* Surcharge Rates */}
      <div>
        {/* <HeadingWithLine text="Pin-Based Debit" /> */}
        <ul>
          <li>
            <div>
              <p>Dual Pricing Rate</p>
              <p>{getPricingDataById(appData, 35).percent}%</p>
            </div>
          </li>          
          <li>
            <div>
              <p>Per Transaction</p>
              <p>{ getPricingDataById(appData, 35)?.dollars ? '$ ' + getPricingDataById(appData, 35)?.dollars : '-' }
              </p>
            </div>
          </li>
          <li>
            <div>
              <p>Monthly Fee</p>
              <p>$ {getPricingDataById(appData, 17).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Pin Based Debit - Removed from dual pricing */}
      {/* <div>
        <HeadingWithLine text="Pin-Based Debit" />
        <ul>
          <li>
            <div>
              <p>Debit Rate</p>
              <p>{getPricingDataById(5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>$ {getPricingDataById(5).dollars}</p>
            </div>
          </li>
        </ul>
      </div> */}
    </>
  );
}

export default DualPricing;
